<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ClLoading",
})
</script>

<template>
  <div class="cl-loading cl-loading--circles cl-loading--target">
    <div class="cl-loading__load" style="transform: scale(0.8);">
      <div class="cl-loading__load__animation">
        <div class="cl-loading__load__percent"></div>
        <div class="cl-loading__load__animation__1"></div>
        <div class="cl-loading__load__animation__2"></div>
        <div class="cl-loading__load__animation__3"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import "@/assets/sass/components/loading";
</style>